import { Component, Input, Injector } from '@angular/core';
import { AppComponentBase } from '@shared/common/app-component-base';

@Component({
  selector: 'vf-file-icon',
  template: ` <lucide-icon name="folder" [size]="16" class="mr-1" draggable="false" *ngIf="!obj?.isLink && (obj?.fileType === 'folder' || obj?.fileType === 'Folder' || obj?.extension === 'folder')"></lucide-icon>
              <lucide-icon name="file-text" [size]="16" class="mr-1" draggable="false" *ngIf="!obj?.isLink && (obj?.fileType === 'otherFile' || obj?.fileType === 'otherfile') && obj?.fileType !== 'Folder' && obj?.fileType !== 'folder' && obj?.extension !== 'folder' && !getExt(obj?.fileType)"></lucide-icon>

              <lucide-icon name="file-text" [size]="16" class="mr-1" draggable="false" *ngIf="getExt(obj?.extension) === '' && !obj?.fileType && !(obj?.extension === 'jpg' || obj?.extension === 'jpeg' || obj?.extension === 'gif' || obj?.extension === 'bmp' || obj?.extension === 'svg' || obj?.extension === 'png' || obj?.fileType === 'jpg' || obj?.fileType === 'jpeg' || obj?.fileType === 'gif' || obj?.fileType === 'bmp' || obj?.fileType === 'svg' || obj?.fileType === 'png') && !(obj?.fileType === 'folder' || obj?.fileType === 'Folder' || obj?.extension === 'folder')"></lucide-icon>

              <lucide-icon name="globe" [size]="16" class="mr-1 pb-02" draggable="false" *ngIf="obj?.isLink || obj?.fileType === 'link' || obj?.extension === 'link'"></lucide-icon>

              <lucide-icon name="image" [size]="16" class="mr-1" draggable="false" *ngIf="obj?.extension === 'jpg' || obj?.extension === 'jpeg' || obj?.extension === 'gif' || obj?.extension === 'bmp' || obj?.extension === 'svg' || obj?.extension === 'png' || obj?.fileType === 'jpg' || obj?.fileType === 'jpeg' || obj?.fileType === 'gif' || obj?.fileType === 'bmp' || obj?.fileType === 'svg' || obj?.fileType === 'png'"></lucide-icon>

              <lucide-icon name="folder" [size]="16" class="mr-1" draggable="false" *ngIf="!obj?.isLink && obj?.fileType === 'documentLibrary'"></lucide-icon>

              <img [src]="getExt(obj?.extension) !== '' ? getExt(obj?.extension): ''" draggable="false"
                *ngIf="obj?.extension && !obj?.fileType && !obj?.isLink && getExt(obj?.extension) && obj?.fileType !== 'documentLibrary' && obj?.fileType !== 'folder' && obj?.fileType !== 'Folder' && obj?.extension !== 'folder'"
                class="text-center w-15 pb-02 mr-10">
              <img [src]="getExt(obj?.fileType) !== '' ? getExt(obj?.fileType): ''" draggable="false"
                *ngIf="obj?.extension && obj?.fileType && !obj?.isLink && getExt(obj?.fileType) && obj?.fileType !== 'documentLibrary' && obj?.fileType !== 'folder' && obj?.fileType !== 'Folder' && obj?.extension !== 'folder'"
                class="text-center w-15 pb-02 mr-10">
              <img [src]="getExt(obj?.fileType) !== '' ? getExt(obj?.fileType): ''" draggable="false"
                *ngIf="!obj?.extension && obj?.fileType && !obj?.isLink && getExt(obj?.fileType) && obj?.fileType !== 'documentLibrary' && obj?.fileType !== 'folder' && obj?.fileType !== 'Folder' && obj?.extension !== 'folder'"
                class="text-center w-15 pb-02 mr-10">

              <lucide-icon name="file-text" [size]="16" class="mr-1" draggable="false" *ngIf="obj && !hasMatchingIcon()"></lucide-icon>`
})
export class FileIconComponent extends AppComponentBase {
  @Input() isSemibold: boolean;
  @Input() obj: any;
  constructor(injector: Injector) {
    super(injector);
  }

  hasMatchingIcon(): boolean {
    if (!this.obj) return false;

    let ext = this.obj.extension;
    let ft = this.obj.fileType;
    let imageExts = ['jpg', 'jpeg', 'gif', 'bmp', 'svg', 'png'];

    // globe
    if (this.obj.isLink || ft === 'link' || ext === 'link') return true;
    // folder
    if (ft === 'folder' || ft === 'Folder' || ext === 'folder') return true;
    // documentLibrary
    if (ft === 'documentLibrary') return true;
    // image
    if (imageExts.indexOf(ext) > -1 || imageExts.indexOf(ft) > -1) return true;
    // otherFile
    if ((ft === 'otherFile' || ft === 'otherfile') && !this.getExt(ft)) return true;
    // no fileType, getExt empty, not image, not folder
    if (this.getExt(ext) === '' && !ft) return true;
    // img with known office extension
    if (this.getExt(ext)) return true;
    if (this.getExt(ft)) return true;

    return false;
  }

  getExt(ext: string): any {
    if (ext && ext !== '' && ext !== null) {
      ext = ext.toLowerCase();
      if (ext === 'doc' || ext === 'docx') {
        return 'https://cdn.trovve.com/vfapp/images/file-icons/word.svg';
      } else if (ext === 'xls' || ext === 'xlsx') {
        return 'https://cdn.trovve.com/vfapp/images/file-icons/excel.svg';
      } else if (ext === 'ppt' || ext === 'pptx') {
        return 'https://cdn.trovve.com/vfapp/images/file-icons/powerpoint.svg';
      } else if (ext === 'vsd' || ext === 'vsdx') {
        return 'https://cdn.trovve.com/vfapp/images/file-icons/visio.svg';
      } else if (ext === 'onenote') {
        return 'https://cdn.trovve.com/vfapp/images/file-icons/onenote.svg';
      } else {
        return '';
      }
    } else {
      return undefined;
    }
  }
}
